import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from '../../../context/translationProvider'
import {
  StyledButtonWrapper,
  StyledIcon,
  StyledTextWraper,
  StyledWrapper,
} from './styles'
import { Text } from '../../atoms/text'
import { Button } from '../../atoms/button'
import HouseIcon from '../../../images/house-icon.svg'

export const BankAccountWithdrawVerification = ({ onClose }) => {
  const { translate } = useTranslation()

  return (
    <StyledWrapper>
      <StyledTextWraper>
        <Text bold>
          {translate('payments.bankAccountKeys.withdrawVerification.title')}
        </Text>

        <StyledIcon src={HouseIcon} alt="Activate Bank Account" />

        <Text>
          {translate(
            'payments.bankAccountKeys.withdrawVerification.description'
          )}
        </Text>
      </StyledTextWraper>

      <StyledButtonWrapper>
        <Button expand href="/account/bank-accounts/" onClick={onClose}>
          {translate(
            'payments.bankAccountKeys.withdrawVerification.goToBankAccount'
          )}
        </Button>

        <Button dark bordered expand onClick={onClose}>
          {translate('payments.bankAccountKeys.withdrawVerification.close')}
        </Button>
      </StyledButtonWrapper>
    </StyledWrapper>
  )
}

BankAccountWithdrawVerification.propTypes = {
  onClose: PropTypes.func.isRequired,
}
